import { Box, Tooltip } from '@mui/material';
import { HIDDEN_FIELD_TOOLTIP } from '../constants.ts';
import { personalDataHiddenFieldSx } from '../styles.ts';

export const HiddenField = () => (
  <Tooltip title={HIDDEN_FIELD_TOOLTIP}>
    <Box sx={personalDataHiddenFieldSx}>**************</Box>
  </Tooltip>
);
